module.exports = "/_next/static/images/sellers_2_ru-45b1345deb3f16f45fc0e41a22a90c7f.png";